// extracted by mini-css-extract-plugin
export default {"cartModal":"CartModal_cartModal__Vm9gV"};